"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttachmentViewer = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _queryString = _interopRequireDefault(require("query-string"));

var _axios = _interopRequireDefault(require("axios"));

var _container = require("../../container");

var _parseDocument = _interopRequireDefault(require("../../lib/utils/helper/parseDocument"));

var _components = require("../../components");

var _DocumentProvider = require("../../context/DocumentProvider");

var AttachmentViewer = function AttachmentViewer(_ref) {
  var getPatientAttachment = _ref.getPatientAttachment;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      attachment = _useState2[0],
      setAttachment = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      page = _useState4[0],
      setPage = _useState4[1];

  var _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
      _useSearchParams2 = (0, _slicedToArray2.default)(_useSearchParams, 2),
      searchParams = _useSearchParams2[0],
      setSearchParams = _useSearchParams2[1];

  var _useContext = (0, _react.useContext)(_DocumentProvider.DocumentContext),
      currentDocument = _useContext.currentDocument;

  var isBase64 = function isBase64(str) {
    try {
      window.atob(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  var getData = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      var params, docAttachment, mediaType, data, xmlDataRes, title, xmlData, isB64, xmlString, xmlDoc;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!currentDocument) {
                _context.next = 34;
                break;
              }

              params = _queryString.default.parse(searchParams.toString());

              if (!(params.attachment && params.attachment.startsWith('http') && getPatientAttachment)) {
                _context.next = 16;
                break;
              }

              mediaType = params.type === 'pdf' ? 'application/pdf' : 'text/xml';
              _context.next = 6;
              return getPatientAttachment(params.attachment);

            case 6:
              data = _context.sent;

              if (!(mediaType === 'text/xml')) {
                _context.next = 12;
                break;
              }

              _context.next = 10;
              return _axios.default.get(data);

            case 10:
              xmlDataRes = _context.sent;
              data = xmlDataRes.data;

            case 12:
              title = params && params.title ? "Attachment: ".concat(params.title) : 'Attachment';
              docAttachment = {
                mediaType: mediaType,
                data: data,
                title: title
              };
              _context.next = 17;
              break;

            case 16:
              docAttachment = currentDocument.attachments.find(function (att) {
                return att.id === params.attachment;
              });

            case 17:
              if (!docAttachment) {
                _context.next = 34;
                break;
              }

              if (!(docAttachment.mediaType === 'application/pdf')) {
                _context.next = 23;
                break;
              }

              if (params.page) {
                setPage(parseInt(params.page));
              }

              setAttachment(docAttachment);
              _context.next = 34;
              break;

            case 23:
              if (!(docAttachment.mediaType === 'text/xml')) {
                _context.next = 33;
                break;
              }

              xmlData = docAttachment.data;
              isB64 = isBase64(xmlData);

              if (isB64) {
                xmlString = window.atob(xmlData);
              } else {
                xmlString = xmlData;
              }

              _context.next = 29;
              return (0, _parseDocument.default)(xmlString);

            case 29:
              xmlDoc = _context.sent;
              setAttachment({
                mediaType: 'text/xml',
                data: xmlDoc,
                rawData: xmlString,
                title: docAttachment.title
              });
              _context.next = 34;
              break;

            case 33:
              if (docAttachment.mediaType === 'text/rtf') {
                setAttachment({
                  mediaType: 'text/rtf',
                  data: docAttachment.data,
                  title: docAttachment.title
                });
              }

            case 34:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getData() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    getData();
  }, [searchParams]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, attachment ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, attachment.mediaType === 'application/pdf' ? /*#__PURE__*/_react.default.createElement(_container.PDFViewer, {
    data: attachment.data,
    page: page
  }) : attachment.mediaType === 'text/xml' ? /*#__PURE__*/_react.default.createElement(_container.XMLViewer, {
    documentTitle: attachment.title,
    data: attachment.data,
    rawData: attachment.rawData
  }) : /*#__PURE__*/_react.default.createElement(_components.Spinner, null)) : /*#__PURE__*/_react.default.createElement(_components.Spinner, null));
};

exports.AttachmentViewer = AttachmentViewer;